import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb56cd92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-history-table-container" }
const _hoisted_2 = { class: "board-filter" }
const _hoisted_3 = {
  key: 0,
  ref: "boardHistoryContentArea",
  class: "board-history-content-area"
}
const _hoisted_4 = {
  role: "list",
  "aria-label": "탑승 내역 목록"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["CalendarInput"], {
        fromDate: $props.searchFromDate,
        toDate: $props.searchToDate,
        dateFormat: 'YYYY.MM.DD',
        onOnClickFromDate: $setup.emitOnClickFromDateInput,
        onOnClickToDate: $setup.emitOnClickToDateInput
      }, null, 8 /* PROPS */, ["fromDate", "toDate"])
    ]),
    ($props.boardHistory.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.boardHistory, (boardInfo) => {
              return (_openBlock(), _createElementBlock("li", {
                key: boardInfo.id,
                class: "board-history-row-wrapper",
                role: "listitem"
              }, [
                _createVNode($setup["BoardHistoryRow"], {
                  class: "board-history-row",
                  boardInfo: boardInfo,
                  onOnClickBoardHistoryRow: $setup.emitOnSelectBoardInfo
                }, null, 8 /* PROPS */, ["boardInfo"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    ($props.shouldShowEmptyContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode($setup["EmptyContent"], {
            class: "empty-content",
            text: "탑승 내역이 없습니다"
          })
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.boardHistoryContentArea)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 2,
          container: $setup.boardHistoryContentArea
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ]))
}